module.exports = "/_next/static/images/51c7080e7160a0bdeacddf8b55b2dc27-girl-and-card-lg.png";